import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PageComponent } from '@softapps/core/pages';
import { CommandStore, SOFTLINE_FEATURE_COMMANDS, title } from '@softline/application';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_ARTIKEL_INFO_UMSATZABFRAGE } from '../artikel-info.shared';
import { UmsatzabfrageStore } from '../store/umsatzabfrage.store';

@Component({
  selector: 'lib-artikel-info',
  templateUrl: './artikel-info.component.html',
  styleUrls: ['./artikel-info.component.css'],
  imports: [RouterModule, PageComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArtikelInfoComponent implements OnInit, OnDestroy {
  constructor(private store: Store) {
    title('#ARTIKELINFO.TITLE');
  }

  async ngOnInit(): Promise<void> {
    this.store.commit(SOFTLINE_FEATURE_COMMANDS, CommandStore.mutations.addSet, {
      name: ArtikelInfoComponent,
      commands: [
        {
          name: '#ARTIKELINFO.MENU.SEARCH',
          class: 'menu main-menu main-menu-top',
          icon: 'fa-regular fa-magnifying-glass',
          routerLink: '/artikel-info',
        },
        {
          name: '#ARTIKELINFO.MENU.FAVORITES',
          class: 'menu main-menu main-menu-top',
          icon: 'fa-regular fa-heart',
          routerLink: '/artikel-info/favoriten',
        },
        {
          name: '#ARTIKELINFO.MENU.SCAN_LIST',
          class: 'menu main-menu main-menu-top',
          icon: 'fa-regular fa-barcode-scan',
          routerLink: '/artikel-info/scan-liste',
        },
      ],
    });

    await this.store.dispatch(
      SOFTLINE_FEATURE_ARTIKEL_INFO_UMSATZABFRAGE,
      UmsatzabfrageStore.actions.loadFilialen
    );
  }

  ngOnDestroy() {
    this.store.commit(
      SOFTLINE_FEATURE_COMMANDS,
      CommandStore.mutations.removeSet,
      ArtikelInfoComponent
    );
  }
}
